<template>
    <card title="GSDD Drug Merge">
        <div>
            <b-row class="pb-1 align-items-center">
                <b-col>
                    <b-form-group :label="gsddDropDownLabel" label-for="gsddChooser">
                        <template #label>{{ gsddDropDownLabel }}<span></span></template>
                        <v-select id="gsddChooser" v-model="gsddMatchDrugIdSelected" :full-width="true"
                            :options="gsddMatchDisplay" :reduce="gsddMatchDisplay => gsddMatchDisplay.id"
                            :select-on-tab="true" class="style-chooser" label="name" @input="onDrugSelected">
                        </v-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <hr>

            <b-col style="float: right">
                <span style="float: right">
                    <b-button variant="danger" @click="clearClicked">
                        Clear
                    </b-button>
                </span>
            </b-col>

            <!--b-row v-show="drugName" class="text-center">
                <b-col>
                    <h2>{{this.drugName}}</h2>
                </b-col>
            </b-row-->
            <b-row v-show="sourceDrug && sourceDrug.productID > -1" class="py-2">
                <b-col>
                    <card>
                        <b-row>
                            <b-col cols="9">
                                <h3 class="card-subtitle"> {{ sourceTitle }} </h3>
                                <b-alert variant="danger">Danger Alert</b-alert>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <span id="brandfiller" class="filler"><strong> &nbsp;</strong></span>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>ProductID: </strong>{{ this.sourceDrug.productID }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>NDC: </strong>{{ this.sourceDrug && this.sourceDrug.ndc }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>AWP: </strong>{{ this.awp }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Package Size: </strong>{{ this.packageSize }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Unit of Measure: </strong>{{ this.unitOfMeasure }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Minimum Dispense Quantity: </strong>{{ this.minimumDispenseQuantity }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>DEA Class: </strong>{{ this.deaClass }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Status: </strong>{{ this.sourceStatus }}
                            </b-col>
                        </b-row>
                    </card>
                </b-col>

                <b-col v-if="drugSelected">
                    <card>
                        <b-row>
                            <b-col cols="9">
                                <h3 class="card-subtitle"> {{ targetTitle }} </h3>
                                <b-alert variant="danger">Danger Alert</b-alert>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <span id="patedfiller1" class="filler"><strong> &nbsp;</strong></span>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>PackageId: </strong>{{ this.gsddMatchDrugIdSelected }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>NDC: </strong>{{ this.targetDrug && this.targetDrug.ndc }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Marketer: </strong>{{ this.marketer }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Description: </strong>{{ this.packageDescription }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Dose Form: </strong>{{ this.doseForm }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>DEA Class: </strong>{{ this.targetDeaClass }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Package Size: </strong>{{ this.targetPackageSize }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Unit Price: </strong>{{ this.drugPrice }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Route of
                                    Administration: </strong>{{ this.targetDrug &&
                                        this.targetDrug.routeOfAdministration }}
                            </b-col>
                        </b-row>
                    </card>
                </b-col>

            </b-row>

            <b-col cols="12">
                <n-button :disabled="!drugSelected" type="success" @click="onSaveClicked">Save Merge</n-button>
                <n-button @click="onCancelClicked">Cancel</n-button>
            </b-col>
        </div>
    </card>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { NonGSDDDrug } from '@/models/Drug/NonGSDDDrug';
import { Drug, DrugStatus } from '@/models/Drug/Drug';
import { DrugView } from '@/models/Drug/DrugView';
import { PackagePrice } from '@/models/GSDD';
import Axios, { AxiosError } from "axios";
import { NotificationOptions } from '@/util/NotificationOptionsPresets';

@Component({
    name: "GSDDMergeModalComponent",
    components: {}
})

export default class GSDDMergeModalComponent extends Vue {
    @Prop() gsddDrugMatch!: Array<DrugView>;
    @Prop() sourceDrug!: NonGSDDDrug;
    readonly labelCols: number | undefined;
    drugSelected: boolean = false;
    protected gsddMatchDisplay: Array<any> = []; //this.gsddDrugMatch.forEach(function(element) {return  element.toString()});
    private gsddDropDownLabel: string = "Comparable GSDD Drugs - Same NDC, PackageSize, UnitOfMeasure";
    private gsddMatchDrugIdSelected: number | null = null;
    private sourceStatus: string | null = DrugStatus.DrugStatusEnum[this.sourceDrug.activeStatus];
    private sourceTitle: string = "Source NonGSDD";
    private targetTitle: string = "Target GSDD";
    private targetDrug: Drug | null = new Drug();
    private targetStatus: number | null = null;
    private isLoading: boolean = false;

    get awp(): any {
        if (!this.sourceDrug || !this.sourceDrug.awp) return ``;
        return `${this.sourceDrug.awp}`;
    }

    get packageSize(): any {
        if (!this.sourceDrug || !this.sourceDrug.packageSize) return ``;
        return `${this.sourceDrug.packageSize}`;
    }

    get unitOfMeasure(): any {
        if (!this.sourceDrug) return ``;
        return this.sourceDrug.unitOfMeasure;
    }

    get minimumDispenseQuantity(): any {
        if (!this.sourceDrug || !this.sourceDrug.minimumDispenseQuantity) return ``;
        return `${this.sourceDrug.minimumDispenseQuantity}`;
    }

    get deaClass(): any {
        if (!this.sourceDrug) return ``;
        return this.sourceDrug.deaClass;
    }

    get disableFields(): boolean {
        return false
    }

    get marketer(): any {
        if (!this.targetDrug) return ``;
        return this.targetDrug.marketer;
    }

    get packageDescription(): any {
        if (!this.targetDrug) return ``;
        return this.targetDrug.packageDescription;
    }

    get doseForm(): any {
        if (!this.targetDrug) return ``;
        return this.targetDrug.doseForm;
    }

    get targetDeaClass(): any {
        if (!this.targetDrug) return ``;
        return this.targetDrug.deaClass;
    }

    get targetPackageSize(): any {
        if (!this.targetDrug || !this.targetDrug.packageSize || !this.targetDrug.billingUnit) return ``;
        return `${this.targetDrug.packageSize} ${this.targetDrug.billingUnit}`;
    }

    // from Price
    get drugPrice(): any {
        if (!this.targetDrug || !this.targetDrug.prices) return ``;
        const filteredPrices = this.targetDrug.prices as PackagePrice[];

        // 1  -- Average Wholesale Price
        // 13 -- Calculated Average Wholesale Price
        // 2  -- Wholesale Acquisition Cost
        const awp = filteredPrices.find(p => p.priceTypeID == 1 || p.priceTypeID == 13);
        const wac = filteredPrices.find(p => p.priceTypeID == 2);

        const awpString = awp && awp.unitPrice ? `AWP: $${awp.unitPrice}/${awp.ncpdpBillingUnit}` : ``;
        const wacString = wac && wac.unitPrice ? `WAC: $${wac.unitPrice}/${wac.ncpdpBillingUnit}` : ``;

        return `${awpString} ${wacString}`;
    }

    @Watch('gsddDrugMatch')
    onGsddDrugMatchChanged(newValue: Array<DrugView>) {
        this.gsddMatchDisplay = [];
        this.gsddMatchDrugIdSelected = null;

        if (!newValue?.length) {
            this.drugSelected = false;
            this.targetDrug = new Drug();
            return;
        }

        newValue.forEach(e => {
            if (e?.drugId && e?.drugName) {
                this.gsddMatchDisplay.push(
                    { id: e.drugId, name: `PackageId: ${e.drugId.toString()}, DrugName: ${e.drugName}` }
                );
            }
        });

        if (this.gsddMatchDisplay.length === 1) {
            this.gsddMatchDrugIdSelected = this.gsddMatchDisplay[0].id;
            this.onDrugSelected();
        }
    }

    created() {
        this.onGsddDrugMatchChanged(this.gsddDrugMatch);
    }

    clearClicked() {
        this.drugSelected = false;
        this.targetDrug = new Drug();
        return;
    }

    async onSaveClicked() {
        let continueSaveMerge = await this.confirmSaveMerge();
        if (!continueSaveMerge) return;
        let sc: number = 0;
        await this.dbMerge(this.sourceDrug.productID!.toString(), this.gsddMatchDrugIdSelected!.toString())
            .then(value => {
                sc = Number(value);
            });
        if (sc != 200) {
            await this.$bvModal.msgBoxOk(`Database error occurred while attempting to save GSDD Merge`);
            return;
        }
        this.$emit('merge');
    }

    onCancelClicked() {
        this.$emit('cancel');
    }

    onDrugSelected() {
        this.drugSelected = true;
        const PackageID = this.gsddMatchDrugIdSelected;
        const packageId = Number(PackageID || 0);
        this.targetDrug = new Drug();
        this.fetchDrug(packageId);
    }

    fetchDrug(packageID: number) {
        if (!packageID) return;

        Axios.get<Drug>(`/Drug/${packageID}`, { params: { getCategories: true, getVendors: true } })
            .then(response => {
                const drug: Drug = response.data;
                this.targetDrug = new Drug(null, drug);
                this.targetStatus = drug.activeStatus;
            })
            .catch(error => {
                console.error('Problem while getting drug details.', { error, response: error?.response });
                this.$notification(NotificationOptions.error(error));
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    async dbMerge(fromPackageId: string, toPackageId: string): Promise<number | undefined> {
        try {
            const response = await Axios.post('/NonGSDD/gsdd-merge', null, {
                params: {
                    fromPackageId: fromPackageId,
                    toPackageId: toPackageId
                }
            });
            const sc: number = Number(response.status);
            return sc;
        } catch (err) {
            const error = err as AxiosError;
            console.error('Error saving GSDD drug merge.', { error, response: error?.response });
            this.$notification(NotificationOptions.error(error));
            return error.response?.status;
        }
    }

    confirmSaveMerge(): Promise<boolean> {
        return this.$bvModal.msgBoxConfirm(`Save Merge will permanently delete Source NonGSDD drug after Merge! - Are you sure?`, {
            title: 'Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        })
            .then(value => {
                return value == null ? false : value;
            })
            .catch(err => {
                console.error("Error caught on verify Save Merge.", err);
                return false;
            })
    }
}
</script>

<style scoped></style>
